import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { FormGroup, Validators, FormBuilder, FormArray } from "@angular/forms";
import { environment } from "../../environments/environment";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import * as moment from "moment";
import { SupportService } from "../services/support-service";
import { FrontDeskSharedService } from "../services/front-desk-shared.service";
import { EmployeeUploadSharedService } from "../services/employee-upload-shared.service";
import { UploadEvent } from "ngx-file-drop";
import { Router } from "@angular/router";

@Component({
  selector: "app-technician",
  templateUrl: "./technician.component.html",
  styleUrls: ["./technician.component.scss"],
})
export class TechnicianComponent implements OnInit {
  modalRef: BsModalRef;
  selectedTechnician: any;
  technicianForm: FormGroup;
  countryList: any;
  technicianinfosubmit = false;
  license: any = [
    {
      license: null,
      licensevalid: true,
      issued: null,
      issuedvalid: true,
      expiry: null,
      expiryvalid: true,
    },
  ];
  schoolAttached: any = [
    {
      schoolAtnd: null,
      schoolAtndvalid: true,
      schoolFrm: null,
      schoolFrmvalid: true,
      schoolTo: null,
      schoolTovalid: true,
    },
  ];
  equipments: any = [{ exam: { id: null } }];
  public myDatePickerOptions: IMyDpOptions = {};
  public terminatePickerOptions: IMyDpOptions = {};
  today = new Date();
  config = {
    ignoreBackdropClick: true,
  };
  month: any;
  @ViewChild("validationPopup") validationPopup: TemplateRef<any>;
  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;
  @ViewChild("editPopup") editPopup: TemplateRef<any>;
  placeholderschlfrom: any = "";
  placeholderschlTo: any = "";
  usertype = "";
  techiedit = "";
  exams: any = [];
  selectedIndex = 0;
  selectedRowIndex = 0;
  uploadFinish = false;
  selectedFiles: FileList;
  generalvalidationMessage = "";
  sizeRestriction = "";
  extendsionRestriction = "";
  extendsionRestrictionMessage = "";
  i = 0;
  docuerror = false;
  remainingPercentage: any;
  validationMessage: any = {};
  techmessage: any = {};
  statedisable = false;
  verifyemail = true;
  verifyusername = true;
  tcCode: any;
  licenseList: any = [];
  schoolList: any = [];
  documentList: any = [];
  equipmentList: any = [];
  registerTechnicianList: any = [];
  backendmessage: any = "";
  mobilechecking = false;
  equipmentFlag = false;
  techSavebutton = false;
  techindex = 0;
  terminateEmpolyee: any = [];
  workingEmpolyee: any = [];
  files: any = [];
  index = 0;
  techid: any = "";
  heading: any = "";
  popuptype: any = "";
  type: any = "";
  oldMobile = "";
  oldMobileCode = "";
  technicianObj: any;
  oldEmail: any = "";
  techEdit = false;
  constructor(
    private appservice: AppService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private datepipe: DatePipe,
    private supportService: SupportService,
    private frontDeskSharedService: FrontDeskSharedService,
    private router: Router,
    private employeeUploadSharedService: EmployeeUploadSharedService
  ) {
    this.technicianForm = formBuilder.group({
      technicianList: formBuilder.array([this.addNewTechnician()]),
    });
    this.selectedTechnician = {};
    this.countryList = [];

    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: true,
      firstDayOfWeek: "su",
      indicateInvalidDate: true,
    };

    this.terminatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: true,
      indicateInvalidDate: true,
    };
  }

  getMonthStr(value): string {
    return this.frontDeskSharedService.getMonthStr(value);
  }

  getMonthNumber(value) {
    return this.frontDeskSharedService.getMonthNumber(value);
  }

  addNewTechnician() {
    return this.formBuilder.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      initial: [""],
      address1: [""],
      address2: [""],
      city: [""],
      state: ["default"],
      zipcode: [""],
      country: ["default"],
      techdialcode: ["default"],
      techMobile: [
        { value: "", disabled: false },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      techdialphn: ["default"],
      techtelphn: [
        { value: "", disabled: false },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      personalemail: [
        "",
        [Validators.pattern(environment.emailPattern)],
      ],
      emergencyContactName: [""],
      emergencyContactDialcode: ["default"],
      emergencyContactNum: [
        { value: "", disabled: false },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      dateHired: [{ date: null }, [Validators.required]],
      terminatedDate: [null],
      documentList: this.formBuilder.array([]),
      vacationhrs: ["", [Validators.required]],
      personalhrs: ["", [Validators.required]],
      sickhrs: ["", [Validators.required]],
      licenseList: this.formBuilder.array([this.addNewLicense()]),
      schoolList: this.formBuilder.array([this.addNewSchool()]),
      technicianMobile: ["0000000000"],
      technicianPhone: ["0000000000"],
      emergencyPhone: ["0000000000"],
      stateList: [],
      equipments: this.formBuilder.array([]),
      emailvalid: [{ value: false }],
      frontendemailvalid: [{ value: true }],
      equipmentsvalid: [{ value: false }],
      technicianId: [""],
      areaName: [""],
      disabled: [{ value: false }],
      primaryEmailValidationmessage: [""],
      ziplength: [0],
      ziperror: [false],
      zipmask: [""],
      ziplable: [""],
    });
  }

  addNewLicense() {
    return this.formBuilder.group({
      id: [""],
      license: [""],
      issued: [{ date: null }],
      expired: [{ date: null }],
      issuedDatePickerOptions: [
        {
          dateFormat: "mmm dd, yyyy",
          maxYear: this.today.getFullYear(),
          disableSince: {
            year: this.today.getFullYear(),
            month: this.today.getMonth() + 1,
            day: this.today.getDate(),
          },
          showClearDateBtn: false,
          editableDateField: true,
          indicateInvalidDate: true,
        },
      ],
      expiredDatePickerOptions: [
        {
          dateFormat: "mmm dd, yyyy",
          showClearDateBtn: false,
          editableDateField: true,
          indicateInvalidDate: true,
        },
      ],
    });
  }

  private minYearDatePickerOptions(event) {
    return {
      dateFormat: "mmm dd, yyyy",
      minYear: +event.date.year,
      disableUntil: {
        year: +event.date.year,
        month: +event.date.month,
        day: +event.date.day,
      },
      showClearDateBtn: false,
      editableDateField: true,
      indicateInvalidDate: true,
    };
  }

  issuedMethod(index, licenseIndex, event) {
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "licenseList"
    ]["controls"][licenseIndex]["controls"][
      "expiredDatePickerOptions"
    ].setValue(this.minYearDatePickerOptions(event));
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "licenseList"
    ]["controls"][licenseIndex]["controls"]["expired"].setValue(null);
  }

  schoolstartMethod(index, schoolIndex, event) {
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "schoolList"
    ]["controls"][schoolIndex]["controls"][
      "schoolendDatePicketOption"
    ].setValue(this.minYearDatePickerOptions(event));
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "schoolList"
    ]["controls"][schoolIndex]["controls"]["schoolTo"].setValue(null);
  }

  addNewSchool() {
    this.placeholderschlfrom =
      this.getMonthStr(this.today.getMonth() + 1) +
      ", " +
      this.today.getFullYear();
    this.placeholderschlTo =
      this.getMonthStr(this.today.getMonth() + 1) +
      ", " +
      this.today.getFullYear();
    return this.formBuilder.group({
      id: [""],
      schoolAtnd: [""],
      schoolFrm: [{ value: "", disabled: false }],
      schoolTo: [{ value: "", disabled: false }],
      valid: [{ value: true }],
      schoolstartDatePicketOption: [
        {
          dateFormat: "mmm dd, yyyy",
          maxYear: this.today.getFullYear(),
          disableSince: {
            year: this.today.getFullYear(),
            month: this.today.getMonth() + 1,
            day: this.today.getDay() - 1,
          },
          showClearDateBtn: false,
          editableDateField: true,
          indicateInvalidDate: true,
        },
      ],
      schoolendDatePicketOption: [
        {
          dateFormat: "mmm dd, yyyy",
          showClearDateBtn: false,
          editableDateField: true,
          indicateInvalidDate: true,
        },
      ],
    });
  }

  checkMonthValidation(frommonthstr, tomonthstr): boolean {
    return this.frontDeskSharedService.checkMonthValidation(this, frommonthstr, tomonthstr);
  }

  checkYearValidation(schoolfromyear, schooltoyear): boolean {
    let flag = false;
    if (schooltoyear < this.today.getFullYear() + 1) {
      if (schoolfromyear < schooltoyear) {
        flag = true;
      } else if (schoolfromyear == schooltoyear) {
        flag = false;
      } else {
        this.validationMessage.schoolfrom =
          "From year should not greater than To year";
        this.validationMessage.schoolto = "";
        flag = false;
      }
    } else {
      this.validationMessage.schoolto = "Year should not be future";
      this.validationMessage.schoolfrom = "";
      flag = false;
    }
    return flag;
  }

  validatefromto(index, schoolindex) {
    if (
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["schoolList"]["controls"][schoolindex]["controls"]["schoolFrm"][
        "value"
      ] &&
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["schoolList"]["controls"][schoolindex]["controls"]["schoolTo"]["value"]
    ) {
      const fromschoolsplit = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["schoolList"]["controls"][schoolindex]["controls"][
        "schoolFrm"
      ]["value"]
        .toString()
        .split(", ");

      const toschoolsplit = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["schoolList"]["controls"][schoolindex]["controls"][
        "schoolTo"
      ]["value"]
        .toString()
        .split(", ");

      if (toschoolsplit.length > 1 && fromschoolsplit.length > 1) {
        const checkyear = this.checkYearValidation(
          fromschoolsplit[1],
          toschoolsplit[1]
        );
        if (!checkyear) {
          if (fromschoolsplit[1] == toschoolsplit[1]) {
            const checkmonth = this.checkMonthValidation(
              fromschoolsplit[0],
              toschoolsplit[0]
            );
            if (!checkmonth) {
              this.validationMessage.schoolto = "";
              this.validationMessage.schoolfrom =
                "From year should not greater then To year";
              this.technicianForm.controls.technicianList["controls"][index][
                "controls"
              ]["schoolList"]["controls"][schoolindex]["controls"][
                "valid"
              ].setValue(false);
              return;
            } else {
              this.validationMessage.schoolto = "";
              this.validationMessage.schoolfrom = "";
              this.technicianForm.controls.technicianList["controls"][index][
                "controls"
              ]["schoolList"]["controls"][schoolindex]["controls"][
                "valid"
              ].setValue(true);
            }
          } else {
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["schoolList"]["controls"][schoolindex]["controls"][
              "valid"
            ].setValue(false);
          }
        } else {
          const frommonth = this.getMonthNumber(
            fromschoolsplit[0].charAt(0).toUpperCase() +
              fromschoolsplit[0].slice(1)
          );
          const tomonth = this.getMonthNumber(
            toschoolsplit[0].charAt(0).toUpperCase() + toschoolsplit[0].slice(1)
          );
          if (frommonth && tomonth) {
            this.validationMessage.schoolto = "";
            this.validationMessage.schoolfrom = "";
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["schoolList"]["controls"][schoolindex]["controls"][
              "valid"
            ].setValue(true);
          } else if (!frommonth) {
            this.validationMessage.schoolto = "";
            this.validationMessage.schoolfrom = "Invalid month";
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["schoolList"]["controls"][schoolindex]["controls"][
              "valid"
            ].setValue(false);
          } else if (!tomonth) {
            this.validationMessage.schoolto = "Invalid month";
            this.validationMessage.schoolfrom = "";
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["schoolList"]["controls"][schoolindex]["controls"][
              "valid"
            ].setValue(false);
          }
        }
      } else {
        this.validationMessage.schoolto = "Invalid date";
        this.validationMessage.schoolfrom = "Invalid date";
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["schoolList"]["controls"][schoolindex]["controls"]["valid"].setValue(
          false
        );
      }
    } else {
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["schoolList"]["controls"][schoolindex]["controls"]["valid"].setValue(
        true
      );
    }
  }

  ngOnInit() {
    this.usertype = sessionStorage.getItem("usertype");

    this.getLanguage();
    this.getcountry();

    if (localStorage.getItem("countryId") != null) {
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "country"
      ].setValue(localStorage.getItem("countryId"));
      this.getStateList(0, localStorage.getItem("countryId"));
      this.changeCountry(0, localStorage.getItem("countryId"));
    }

    if (this.usertype == "1") {
      this.techiedit = sessionStorage.getItem("techiedit");
      this.techEdit = true;
      if (sessionStorage.getItem("techieId") != null) {
        this.popuptype = "modify";
        this.modifyTechnician(sessionStorage.getItem("techieId"));
      }
    } else {
      this.getallExams(0, localStorage.getItem("testCenterId"));
      this.getAllTechinicanByTestCenter();
      this.getAllTerminateTechnicianByTestCenter();
    }
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  addTechnician() {
    const technicianArray = <FormArray>(
      this.technicianForm.controls["technicianList"]
    );
    technicianArray.push(this.addNewTechnician());
    const index = this.technicianForm.controls.technicianList["controls"]
      .length;
    if (this.exams && this.exams.length > 0) {
      if (localStorage.getItem("countryId") != null) {
        this.technicianForm.controls.technicianList["controls"][index - 1][
          "controls"
        ]["country"].setValue(localStorage.getItem("countryId"));
        if (localStorage.getItem("countryId") == "101") {
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["techdialcode"].setValue("+91");
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["techdialphn"].setValue("+91");
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["emergencyContactDialcode"].setValue("+91");
        }

        if (localStorage.getItem("countryId") == "231") {
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["techdialcode"].setValue("+1");
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["techdialphn"].setValue("+1");
          this.technicianForm.controls.technicianList["controls"][index - 1][
            "controls"
          ]["emergencyContactDialcode"].setValue("+1");
        }

        this.getStateList(index - 1, localStorage.getItem("countryId"));
        this.changeCountry(index - 1, localStorage.getItem("countryId"));
      } else {
        this.technicianForm.controls.technicianList["controls"][index - 1][
          "controls"
        ]["country"].setValue("default");
        this.technicianForm.controls.technicianList["controls"][index - 1][
          "controls"
        ]["techdialcode"].setValue("default");
        this.technicianForm.controls.technicianList["controls"][index - 1][
          "controls"
        ]["techdialphn"].setValue("default");
        this.technicianForm.controls.technicianList["controls"][index - 1][
          "controls"
        ]["emergencyContactDialcode"].setValue("default");
      }

      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["state"].setValue("default");
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["dateHired"].setValue({ date: null });
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["equipments"] = this.formBuilder.array([]);
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["terminatedDate"].setValue({ date: null });
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["schoolList"] = this.formBuilder.array([this.addNewSchool()]);
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["licenseList"] = this.formBuilder.array([this.addNewLicense()]);
      this.technicianForm.controls.technicianList["controls"][index - 1][
        "controls"
      ]["documentList"] = this.formBuilder.array([]);
      this.getallExams(index - 1, localStorage.getItem("testCenterId"));
    }
    this.technicianinfosubmit = false;
  }

  removeTechnician(index) {
    const technicianArray = <FormArray>(
      this.technicianForm.controls["technicianList"]
    );
    if (technicianArray.length > 1) {
      technicianArray.removeAt(index);
    }
  }

  getallExams(i, tcId) {
    this.appservice.getAllExamswithTcIdForTech(tcId).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.exams = [];
          if (res["entity"] && res["entity"].length > 0) {
            for (let index = 0; index < res["entity"].length; index++) {
              if (
                res["entity"][index]["active"] ||
                res["entity"][index]["active"] == "true"
              ) {
                this.exams.push(res["entity"][index]);
                this.technicianForm.controls.technicianList["controls"][i][
                  "controls"
                ]["equipments"]["controls"].push(
                  this.formBuilder.group({
                    checked: [true, Validators.required],
                    active: [
                      res["entity"][index]["active"],
                      Validators.required,
                    ],
                    exam: [res["entity"][index]["exam"], Validators.required],
                    id: [res["entity"][index]["id"], Validators.required],
                    examshortname: [
                      res["entity"][index]["examshortname"] === "MRI" ||
                      res["entity"][index]["examshortname"] === "CTS"
                        ? res["entity"][index]["examshortname"] === "MRI"
                          ? "MRI/MRA"
                          : "CTS/CTA"
                        : res["entity"][index]["examshortname"],
                      Validators.required,
                    ],
                    deleted: [
                      res["entity"][index]["deleted"],
                      Validators.required,
                    ],
                  })
                );
              }
            }
          }
        } else {
          this.exams = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  addLicenses(i) {
    let valid = true;
    if (
      this.technicianForm.controls.technicianList["controls"][i]["controls"][
        "licenseList"
      ].length > 0
    ) {
      for (
        let index = 0;
        index <
        this.technicianForm.controls.technicianList["controls"][i]["controls"][
          "licenseList"
        ].length;
        index++
      ) {
        if (
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["licenseList"]["controls"][index]["controls"]["license"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["licenseList"]["controls"][index]["controls"]["issued"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["licenseList"]["controls"][index]["controls"]["issued"]["value"]
            .date &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["licenseList"]["controls"][index]["controls"]["expired"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["licenseList"]["controls"][index]["controls"]["expired"]["value"]
            .date
        ) {
          valid = true;
        } else {
          valid = false;
        }
      }
    }
    if (valid) {
      this.technicianForm.controls.technicianList["controls"][i]["controls"][
        "licenseList"
      ]["controls"].push(this.addNewLicense());
    } else {
      this.generalvalidationMessage = this.techmessage.fillLicenceDetail;
      this.openModal(this.generalvalidation);
    }
  }

  removeLicense(index, licenseIndex) {
    this.selectedIndex = index;
    this.selectedRowIndex = licenseIndex;
    this.popuptype = "removelicense";
    this.heading = "Info";
    this.generalvalidationMessage = "Do you want to remove the license?";
    this.openModal(this.deletePopup);
  }

  removeSchool(index, schoolIndex) {
    this.selectedIndex = index;
    this.selectedRowIndex = schoolIndex;
    this.popuptype = "removeschool";
    this.heading = "Info";
    this.generalvalidationMessage = "Do you want to remove the school?";
    this.openModal(this.deletePopup);
  }

  addSchool(i) {
    let valid = true;
    if (
      this.technicianForm.controls.technicianList["controls"][i]["controls"][
        "schoolList"
      ].length > 0
    ) {
      for (
        let index = 0;
        index <
        this.technicianForm.controls.technicianList["controls"][i]["controls"][
          "schoolList"
        ].length;
        index++
      ) {
        if (
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["schoolList"]["controls"][index]["controls"]["schoolAtnd"][
            "value"
          ] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["schoolList"]["controls"][index]["controls"]["schoolFrm"][
            "value"
          ] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["schoolList"]["controls"][index]["controls"]["schoolFrm"]["value"]
            .date &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["schoolList"]["controls"][index]["controls"]["schoolTo"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][i][
            "controls"
          ]["schoolList"]["controls"][index]["controls"]["schoolTo"]["value"]
            .date
        ) {
          valid = true;
        } else {
          valid = false;
        }
      }
    }
    if (valid) {
      this.technicianForm.controls.technicianList["controls"][i]["controls"][
        "schoolList"
      ]["controls"].push(this.addNewSchool());
    } else {
      this.generalvalidationMessage = this.techmessage.fillSchoolDetail;
      this.openModal(this.generalvalidation);
    }
  }

  dateHiredMethod(index, event) {
    this.terminatePickerOptions = this.minYearDatePickerOptions(event);
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "terminatedDate"
    ].setValue(null);
  }

  dateTerminateMethod(index, date) {}
  submitTechinfo() {
    for (
      let index = 0;
      index < this.technicianForm.controls.technicianList["controls"].length;
      index++
    ) {
      if (
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["country"].value == 231 ||
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["country"].value == "231"
      ) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["areaName"].setValue(
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["city"]["value"]
        );
      }
      if (
        index + 1 ==
        this.technicianForm.controls.technicianList["controls"].length
      ) {
        document.getElementById("triggerform").click();
      }
    }
  }

  documentUpload(index, files) {
    this.selectedFiles = files;
    const file = this.selectedFiles;
    if (file && file.length > 0) {
      if (this.i >= file.length) {
        this.i = 0;
        if (this.docuerror) {
          let sizemessage = "";
          let extnmessage = "";
          if (this.sizeRestriction && !this.extendsionRestriction) {
            sizemessage = this.sizeRestriction;
          }
          if (this.sizeRestriction && this.extendsionRestriction) {
            sizemessage = "," + this.sizeRestriction;
          }
          if (this.extendsionRestriction) {
            extnmessage = this.extendsionRestriction + "invalid file format ";
          }
          this.backendmessage = "";
          this.extendsionRestrictionMessage = extnmessage + sizemessage;
          setTimeout(() => {
            this.extendsionRestriction = "";
            this.sizeRestriction = "";
            this.extendsionRestrictionMessage = "";
          }, 5000);
        }
        return;
      }
      const checkValidFile = this.appservice.getCredential(file[this.i]);
      if (
        checkValidFile.fileExtenstion.toLowerCase() == "txt" ||
        checkValidFile.fileExtenstion.toLowerCase() == "docx" ||
        checkValidFile.fileExtenstion.toLowerCase() == "csv" ||
        checkValidFile.fileExtenstion.toLowerCase() == "wps" ||
        checkValidFile.fileExtenstion.toLowerCase() == "doc" ||
        checkValidFile.fileExtenstion.toLowerCase() == "xlsx" ||
        checkValidFile.fileExtenstion.toLowerCase() == "pdf" ||
        checkValidFile.fileExtenstion.toLowerCase() == "jpeg" ||
        checkValidFile.fileExtenstion.toLowerCase() == "jpg" ||
        checkValidFile.fileExtenstion.toLowerCase() == "png" ||
        checkValidFile.fileExtenstion.toLowerCase() == "gif" ||
        checkValidFile.fileExtenstion.toLowerCase() == "tif" ||
        checkValidFile.fileExtenstion.toLowerCase() == "xls"
      ) {
        const w = file[this.i].size;
        if (w > 0 && +w <= 20000000) {
          const params = this.appservice.getParams(
            file[this.i],
            checkValidFile
          );
          const key = params.Key;
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["documentList"]["controls"].push(
            this.formBuilder.group({
              id: [""],
              documentoriginalname: [checkValidFile.fileName],
              uploaddoc: [key],
              uploadFinish: [true],
              uploadValid: [true],
              percentage: [0],
              errorMessage: [""],
            })
          );
          this.awsUploadFile(
            file[this.i],
            params,
            index,
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["documentList"]["controls"].length
          );
        } else {
          this.docuerror = true;
          this.sizeRestriction += "File Should be below 20 MB" + " ";
          this.i += 1;
          this.documentUpload(index, this.selectedFiles);
        }
      } else {
        this.docuerror = true;
        this.extendsionRestriction += "." + checkValidFile.fileExtenstion + " ";
        this.i += 1;
        this.documentUpload(index, this.selectedFiles);
      }
    } else {
      this.i = 0;
    }
  }

  downloadDoc(key) {
    return this.frontDeskSharedService.downloadDoc(this, key);
  }

  progressBarValue(percentage, index, i) {
    this.remainingPercentage = percentage;
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "documentList"
    ]["controls"][i - 1]["controls"]["percentage"].setValue(
      this.remainingPercentage
    );
    if (
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["documentList"]["controls"][i - 1]["controls"]["percentage"]["value"] ==
      100
    ) {
      this.i += 1;
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["documentList"]["controls"][i - 1]["controls"]["uploadFinish"].setValue(
        false
      );
      this.documentUpload(index, this.selectedFiles);
    }
  }

  awsUploadFile(file, params, index, i) {
    return this.employeeUploadSharedService.awsUploadFile(
      this,
      file,
      params,
      index,
      i
    );
  }

  getLanguage() {
    return this.frontDeskSharedService.getLanguage(this);
  }

  resetexam(index) {
    setTimeout(() => {
      let flag = false;
      if (
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["equipments"] &&
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["equipments"]["controls"].length > 0
      ) {
        for (
          let k = 0;
          k <
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["equipments"]["controls"].length;
          k++
        ) {
          if (
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["equipments"]["controls"][k]["value"]["checked"] === true
          ) {
            flag = true;
          }
        }
      }
      if (flag === true) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["equipmentsvalid"].setValue(true);
      } else {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["equipmentsvalid"].setValue(false);
      }
    }, 500);
  }

  changeCountry(index, countryId) {
    if (countryId && countryId > 0) {
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["state"].setValue("default");
      this.getStateList(index, countryId);
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["zipcode"].setValue("");
      if (countryId == "101" || countryId == 101) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziplength"].setValue(6);
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziplable"].setValue("Pin code");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["zipmask"].setValue("000000");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziperror"].setValue(false);
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["areaName"].setValue("");
  
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["techdialcode"].setValue("+91");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.indiaPhoneMask);

        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["techdialphn"].setValue("+91");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.indiaPhoneMask);

        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyContactDialcode"].setValue("+91");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryId == "231" || countryId == 231) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziplength"].setValue(5);
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["zipmask"].setValue("00000");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziplable"].setValue("Zip code");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziperror"].setValue(false);
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["techdialcode"].setValue("+1");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.usPhoneMask);
       
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["techdialphn"].setValue("+1");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.usPhoneMask);

        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyContactDialcode"].setValue("+1");
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.usPhoneMask);
      }
     
    }
  }

  changeCountrycode(index, countryid, type) {
    if (type == "techdialcode") {
      if (countryid == "+91" || countryid == +91) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.usPhoneMask);
      }
    } else if (type == "techdialphn") {
      if (countryid == "+91" || countryid == +91) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.usPhoneMask);
      }
    } else if (type == "emergencyContactDialcode") {
      if (countryid == "+91" || countryid == +91) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.usPhoneMask);
      }
    }
  }

  verifyEmail(email, index) {
    if (this.techEdit) {
      if (
        email &&
        email != null &&
        email.match(environment.emailPattern) &&
        this.oldEmail != email &&
        this.verifyemail === true
      ) {
        this.verifyTechnicianEmail(email, index);
      }
      if (this.oldEmail == email) {
        this.validationMessage.primaryEmailValidationmessage = "";
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["emailvalid"].setValue(true);
      }
    } else if (this.popuptype != "modify") {
      if (
        email &&
        email != null &&
        email.match(environment.emailPattern) &&
        this.verifyemail === true
      ) {
        this.verifyTechnicianEmail(email, index);
      }
    }
  }

  private verifyTechnicianEmail(email, index) {
    this.verifyemail = false;
    this.appservice.checkTechnician(email).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] == 204
        ) {
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["emailvalid"].setValue(true);
        }
        this.verifyemail = true;
      },
      (err) => {
        this.appservice.sessionOut(err);
        if (
          err &&
          err["error"] &&
          err["error"]["status"] &&
          err["error"]["status"]["status"] == 302
        ) {
          this.generalvalidationMessage = this.techmessage.alreadyexists;
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["emailvalid"].setValue(false);
          this.validationMessage.primaryEmailValidationmessage =
            "Email already exists";
          this.openModal(this.generalvalidation);
        }
        this.verifyemail = true;
        return;
      }
    );
  }

  checkEmailValidationMessage(value) {
    if (this.technicianinfosubmit === true) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryEmailValidationmessage = "";
      }
    }
  }

  checkPersonalEmailValidationMessage(value) {
    if (this.technicianinfosubmit === true) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryPersonalEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryPersonalEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryPersonalEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryPersonalEmailValidationmessage = "";
      }
    }
  }

  yearValidation(value): number {
    return this.frontDeskSharedService.yearValidation(this, value);
  }

  monthValidation(value): number {
    return this.frontDeskSharedService.monthValidation(this, value);
  }

  dayValidation(value, totalday): number {
    return this.frontDeskSharedService.dayValidation(this, value, totalday);
  }

  checkTotalDaycount(month): number {
    return this.frontDeskSharedService.checkTotalDaycount(this, month);
  }

  validateDate(index, i) {
    if (
      this.technicianinfosubmit &&
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["licenseList"]["controls"][i]["controls"]["issued"]["valid"] &&
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["licenseList"]["controls"][i]["controls"]["expired"]["valid"]
    ) {
      const issuedonlist = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["licenseList"]["controls"][i]["controls"]["issued"][
        "value"
      ].split("-");
      const expiredonlist = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["licenseList"]["controls"][i]["controls"]["expired"][
        "value"
      ].split("-");

      const year1 = this.yearValidation(issuedonlist[0]);
      const month1 = this.monthValidation(issuedonlist[1]);
      const count1 = this.checkTotalDaycount(issuedonlist[1]);
      const day1 = this.dayValidation(issuedonlist[2], count1);
      const year2 = +expiredonlist[0] > +year1 ? +expiredonlist[0] : 0;
      const month2 = this.monthValidation(+expiredonlist[1]);
      const count2 = this.monthValidation(+expiredonlist[1]);
      const day2 = this.dayValidation(+expiredonlist[2], +count2);

      if (
        year1 > 0 &&
        month1 > 0 &&
        day1 > 0 &&
        year2 > 0 &&
        month2 > 0 &&
        day2 > 0
      ) {
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["licenseList"]["controls"][i]["controls"]["valid"].setValue(true);
      } else {
        this.validationMessage.issued = "Please Enter valid issue date";
        this.validationMessage.expired = "Please Enter valid expired date";
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["licenseList"]["controls"][i]["controls"]["valid"].setValue(false);
      }
    }
  }

  resetEmail(index) {
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "emailvalid"
    ].setValue(true);
    this.technicianForm.controls.technicianList["controls"][index]["controls"][
      "frontendemailvalid"
    ].setValue(true);
  }

  checkziplength(event, index) {
    if (
      event &&
      event.length !=
        this.technicianForm.controls.technicianList["controls"][index][
          "controls"
        ]["ziplength"]["value"]
    ) {
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["ziperror"].setValue(true);
    } else {
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["ziperror"].setValue(false);
    }
  }

  saveTechnicianObj(techinfo, registerTechnicianList) {
    for (let index = 0; index < techinfo.controls.length; index++) {
      this.licenseList = [];
      this.schoolList = [];
      this.equipmentList = [];
      this.documentList = [];
      this.equipmentFlag = false;
      // if (techinfo.controls[index]["controls"]["state"]["value"] == "default") {
      //   this.openModal(this.validationPopup);
      //   this.techSavebutton = false;
      //   return;
      // }

      if (
        !techinfo.controls[index]["controls"]["dateHired"]["value"] ||
        !techinfo.controls[index]["controls"]["dateHired"]["value"]["date"]
      ) {
        this.openModal(this.validationPopup);
        this.techSavebutton = false;
        return;
      }

      if (techinfo.controls && techinfo.controls.length > 0) {
        for (
          let k = 0;
          k <
          techinfo.controls[index]["controls"]["equipments"]["controls"].length;
          k++
        ) {
          if (
            techinfo.controls[index]["controls"]["equipments"]["controls"][k][
              "value"
            ]["checked"]
          ) {
            this.equipmentFlag = true;
          }
        }
      }

      for (let i = 0; i < techinfo.controls[index]["controls"].length; i++) {
        if (techinfo.controls[index]["controls"]["zipcode"].value && 
          techinfo.controls[index]["controls"]["zipcode"].value.length !=
          techinfo.controls[index]["controls"]["ziplength"].value
        ) {
          techinfo.controls[index]["controls"]["ziperror"].setValue(true);
          return;
        }
      }

      if (!this.equipmentFlag) {
        this.openModal(this.validationPopup);
        techinfo.controls[index]["controls"]["equipmentsvalid"].setValue(false);
        this.techSavebutton = false;
        return;
      } else {
        techinfo.controls[index]["controls"]["equipmentsvalid"].setValue(true);
      }

      if (
        techinfo.controls[index]["controls"]["licenseList"]["controls"].length >
        0
      ) {
        for (
          let i = 0;
          i <
          techinfo.controls[index]["controls"]["licenseList"]["controls"]
            .length;
          i++
        ) {
          if (
            techinfo.controls[index]["controls"]["licenseList"]["controls"][i][
              "controls"
            ]["license"]["value"] &&
            techinfo.controls[index]["controls"]["licenseList"]["controls"][i][
              "controls"
            ]["issued"]["value"] &&
            techinfo.controls[index]["controls"]["licenseList"]["controls"][i][
              "controls"
            ]["issued"]["value"].date &&
            techinfo.controls[index]["controls"]["licenseList"]["controls"][i][
              "controls"
            ]["expired"]["value"] &&
            techinfo.controls[index]["controls"]["licenseList"]["controls"][i][
              "controls"
            ]["expired"]["value"].date
          ) {
            const issuedon =
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["issued"]["value"].date.year +
              "-" +
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["issued"]["value"].date.month +
              "-" +
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["issued"]["value"].date.day;
            const expiredon =
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["expired"]["value"].date.year +
              "-" +
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["expired"]["value"].date.month +
              "-" +
              techinfo.controls[index]["controls"]["licenseList"]["controls"][
                i
              ]["controls"]["expired"]["value"].date.day;
            const licenselist = {
              license:
                techinfo.controls[index]["controls"]["licenseList"]["controls"][
                  i
                ]["controls"]["license"]["value"],
              issuedOn: issuedon,
              expiredOn: expiredon,
            };
            this.licenseList.push(licenselist);
          }
        }
      }

      if (
        techinfo.controls[index]["controls"]["schoolList"]["controls"].length >
        0
      ) {
        for (
          let i = 0;
          i <
          techinfo.controls[index]["controls"]["schoolList"]["controls"].length;
          i++
        ) {
          if (
            techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
              "controls"
            ]["schoolAtnd"]["value"] &&
            techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
              "controls"
            ]["schoolFrm"]["value"] &&
            techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
              "controls"
            ]["schoolFrm"]["value"].date &&
            techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
              "controls"
            ]["schoolTo"]["value"] &&
            techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
              "controls"
            ]["schoolTo"]["value"].date
          ) {
            const start =
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolFrm"]["value"].date.year +
              "-" +
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolFrm"]["value"].date.month +
              "-" +
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolFrm"]["value"].date.day;
            const end =
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolTo"]["value"].date.year +
              "-" +
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolTo"]["value"].date.month +
              "-" +
              techinfo.controls[index]["controls"]["schoolList"]["controls"][i][
                "controls"
              ]["schoolTo"]["value"].date.day;
            const schoollist = {
              school:
                techinfo.controls[index]["controls"]["schoolList"]["controls"][
                  i
                ]["controls"]["schoolAtnd"]["value"],
              fromYear: start,
              toYear: end,
            };
            this.schoolList.push(schoollist);
          }
        }
      }

      for (
        let i = 0;
        i <
        techinfo.controls[index]["controls"]["equipments"]["controls"].length;
        i++
      ) {
        if (
          techinfo.controls[index]["controls"]["equipments"]["controls"][i][
            "controls"
          ]["checked"]["value"]
        ) {
          const equipment = {
            exam: {
              id:
                techinfo.controls[index]["controls"]["equipments"]["controls"][
                  i
                ]["controls"]["id"]["value"],
            },
          };
          this.equipmentList.push(equipment);
        }
      }

      for (
        let ii = 0;
        ii <
        techinfo.controls[index]["controls"]["documentList"]["controls"].length;
        ii++
      ) {
        if (
          techinfo.controls[index]["controls"]["documentList"]["controls"][ii][
            "controls"
          ]["documentoriginalname"]["value"] &&
          techinfo.controls[index]["controls"]["documentList"]["controls"][ii][
            "controls"
          ]["uploaddoc"]["value"] &&
          techinfo.controls[index]["controls"]["documentList"]["controls"][ii][
            "controls"
          ]["uploadValid"]["value"]
        ) {
          const documentObj = {
            documentoriginalname:
              techinfo.controls[index]["controls"]["documentList"]["controls"][
                ii
              ]["controls"]["documentoriginalname"]["value"],
            document:
              techinfo.controls[index]["controls"]["documentList"]["controls"][
                ii
              ]["controls"]["uploaddoc"]["value"],
          };
          this.documentList.push(documentObj);
        }
      }

      if (!techinfo.controls[index]["controls"]["sickhrs"]["value"]) {
        techinfo.controls[index]["controls"]["sickhrs"].setErrors({
          required: true,
        });
      }
      if (!techinfo.controls[index]["controls"]["personalhrs"]["value"]) {
        techinfo.controls[index]["controls"]["personalhrs"].setErrors({
          required: true,
        });
      }
      if (!techinfo.controls[index]["controls"]["vacationhrs"]["value"]) {
        techinfo.controls[index]["controls"]["vacationhrs"].setErrors({
          required: true,
        });
      }

      if (
        !techinfo.controls[index]["controls"]["sickhrs"]["value"] ||
        !techinfo.controls[index]["controls"]["personalhrs"]["value"] ||
        !techinfo.controls[index]["controls"]["vacationhrs"]["value"]
      ) {
        this.openModal(this.validationPopup);
        this.techSavebutton = false;
        return;
      }

      let datehired = null;
      let terminatedate = null;
      if (
        techinfo.controls[index]["controls"]["dateHired"]["value"] &&
        techinfo.controls[index]["controls"]["dateHired"]["value"].date
      ) {
        datehired =
          techinfo.controls[index]["controls"]["dateHired"]["value"].date.year +
          "-" +
          techinfo.controls[index]["controls"]["dateHired"]["value"].date
            .month +
          "-" +
          techinfo.controls[index]["controls"]["dateHired"]["value"].date.day;
      }
      if (
        techinfo.controls[index]["controls"]["terminatedDate"]["value"] &&
        techinfo.controls[index]["controls"]["terminatedDate"]["value"].date
      ) {
        terminatedate =
          techinfo.controls[index]["controls"]["terminatedDate"]["value"].date
            .year +
          "-" +
          techinfo.controls[index]["controls"]["terminatedDate"]["value"].date
            .month +
          "-" +
          techinfo.controls[index]["controls"]["terminatedDate"]["value"].date
            .day;
      }

      var data = {
        technicianId:
          this.technicianObj && this.technicianObj.id
            ? this.technicianObj.id
            : "",
        testCenterId: localStorage.getItem("testCenterId"),
        firstName: techinfo.controls[index]["controls"]["firstName"]["value"],
        lastName: techinfo.controls[index]["controls"]["lastName"]["value"],
        initial: techinfo.controls[index]["controls"]["initial"]["value"]
          .toString()
          .toUpperCase(),
        userName: techinfo.controls[index]["controls"]["email"]["value"],
        address: {
          id: (this.technicianObj && this.technicianObj.address && this.technicianObj.address.id)
            ? this.technicianObj.address.id
            : "",
          street: "",
          addressLine1:
            techinfo.controls[index]["controls"]["address1"]["value"],
          addressLine2:
            techinfo.controls[index]["controls"]["address2"]["value"],
          cityName: techinfo.controls[index]["controls"]["city"]["value"],
          areaName: techinfo.controls[index]["controls"]["areaName"]["value"],
          state: {
            id: (techinfo.controls[index]["controls"]["state"]["value"] && techinfo.controls[index]["controls"]["state"]["value"] != 'default')?techinfo.controls[index]["controls"]["state"]["value"]:0,
          },
          country: {
            id: techinfo.controls[index]["controls"]["country"]["value"],
          },
          zipCode: techinfo.controls[index]["controls"]["zipcode"]["value"],
        },
        phoneCode: techinfo.controls[index]["controls"]["techdialphn"]["value"],
        phoneNumber:
          techinfo.controls[index]["controls"]["techtelphn"]["value"],
        telCode: techinfo.controls[index]["controls"]["techdialcode"]["value"],
        telNumber: techinfo.controls[index]["controls"]["techMobile"]["value"],
        email: techinfo.controls[index]["controls"]["email"]["value"],
        personalEmail:
          techinfo.controls[index]["controls"]["personalemail"]["value"],
        emergencyContactInfo: {
          firstName:
            techinfo.controls[index]["controls"]["emergencyContactName"][
              "value"
            ],
          lastName: "technician",
          phoneNumber:
            techinfo.controls[index]["controls"]["emergencyContactNum"][
              "value"
            ],
          phoneCode:
            techinfo.controls[index]["controls"]["emergencyContactDialcode"][
              "value"
            ],
        },
        document: this.documentList,
        dateHired: datehired,
        dateTerminated: terminatedate,
        sickDays: techinfo.controls[index]["controls"]["sickhrs"]["value"],
        personalDays:
          techinfo.controls[index]["controls"]["personalhrs"]["value"],
        vacationDays:
          techinfo.controls[index]["controls"]["vacationhrs"]["value"],
        equipments: this.equipmentList,
        license: this.licenseList,
        school: this.schoolList,
      };
      registerTechnicianList.push(data);
    }
    if (this.technicianObj && this.techEdit) {
      this.appservice.updateTechnician(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] == 200) {
            this.backendmessage = this.techmessage.updateTech;
            setTimeout(() => {
              this.backendmessage = "";
            }, 3000);

            if (this.usertype == "2") {
              this.cancelModify();
              this.getAllTechinicanByTestCenter();
              this.getAllTerminateTechnicianByTestCenter();
            }
          } else {
            this.openModal(this.validationPopup);
            return;
          }
          this.techSavebutton = false;
        },
        (err) => {
          this.appservice.sessionOut(err);
          this.techSavebutton = false;
        }
      );
    } else {
      const final = {
        techInputs: registerTechnicianList,
      };
      this.appservice.registerTechnician(final).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] == 200) {
            this.backendmessage = this.techmessage.techAddSuccess;
            setTimeout(() => {
              this.backendmessage = "";
            }, 5000);
            this.cancelModify();
            this.getAllTechinicanByTestCenter();
            this.getAllTerminateTechnicianByTestCenter();

            if (
              localStorage.getItem("subscriptionflag") != null &&
              localStorage.getItem("subscriptionflag") == "false"
            ) {
              setTimeout(() => {
                this.router.navigate([
                  localStorage.getItem("testCode").toString().trim(),
                  "front-desk",
                ]);
              }, 1500);
            }
          } else {
            this.openModal(this.validationPopup);
            return;
          }
          this.techSavebutton = false;
        },
        (err) => {
          this.techSavebutton = false;
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  backToTechnologist() {
    this.router.navigate([this.tcCode + "/technologist"]);
  }

  private buildIssuedExpiredDates(issueddate, expireddate) {
    var issuedon = null;
    var expired = null;
    if (issueddate && issueddate.length > 1) {
      issuedon = {
        date: {
          year: issueddate[0],
          month:
            expireddate[1].charAt(0) == "0" || issueddate[1].charAt(0) == 0
              ? issueddate[1].charAt(1)
              : issueddate[1],
          day:
            issueddate[2].charAt(0) == "0" || issueddate[2].charAt(0) == 0
              ? issueddate[2].charAt(1)
              : issueddate[2],
        },
      };
    }

    if (expireddate && expireddate.length > 1) {
      expired = {
        date: {
          year: expireddate[0],
          month:
            expireddate[1].charAt(0) == "0" || expireddate[1].charAt(0) == 0
              ? expireddate[1].charAt(1)
              : expireddate[1],
          day:
            expireddate[2].charAt(0) == "0" || expireddate[2].charAt(0) == 0
              ? expireddate[2].charAt(1)
              : expireddate[2],
        },
      };
    }
    return { issuedon, expired };
  }

  private checkTechnicianEmail(techinfo, index, email) {
    this.appservice.checkTechnician(email).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] == 204
        ) {
          techinfo.controls[index]["controls"]["emailvalid"].setValue(true);
          this.techindex += 1;
          if (techinfo.controls.length == index + 1) {
            this.saveTechnicianObj(techinfo, this.registerTechnicianList);
          } else {
            this.registerTechnician(techinfo, this.techindex);
          }
        } else {
          this.techSavebutton = false;
          this.openModal(this.generalvalidation);
          return;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
        if (
          err &&
          err["error"] &&
          err["error"]["status"]["status"] &&
          err["error"]["status"]["status"] == 302
        ) {
          this.generalvalidationMessage = this.techmessage.alreadyexists;
          techinfo.controls[index]["controls"]["emailvalid"].setValue(false);
          this.validationMessage.primaryEmailValidationmessage =
            "Email already exists";
          techinfo.controls[index]["controls"][
            "primaryEmailValidationmessage"
          ].setValue(this.techmessage.alreadyexists);
          this.techSavebutton = false;
          this.openModal(this.generalvalidation);
          return;
        }
      }
    );
  }

  registerTechnician(techinfo, techindexvalue) {
    this.techindex = techindexvalue;
    if (this.techindex == 0) {
      this.technicianinfosubmit = true;
      this.techSavebutton = true;
      this.registerTechnicianList = [];
    }

    if (techinfo.valid && techinfo.status == "VALID") {
      if (!this.techEdit && this.techindex == 0) {
        for (let index = 0; index < techinfo.controls.length; index++) {
          for (let eindex = 0; eindex < techinfo.controls.length; eindex++) {
            if (index != eindex) {
              if (
                techinfo.controls[index]["controls"]["email"]["value"] ==
                techinfo.controls[eindex]["controls"]["email"]["value"]
              ) {
                techinfo.controls[index]["controls"][
                  "frontendemailvalid"
                ].setValue(false);
                techinfo.controls[index]["controls"][
                  "primaryEmailValidationmessage"
                ].setValue("You have entered duplicate Technologist email.");
                this.techSavebutton = false;
                this.openModal(this.validationPopup);
                return;
              }
            }
          }
        }
      }

      const index = this.techindex;
      if (index < techinfo.controls.length) {
        const email = techinfo.controls[index]["controls"]["email"]["value"]
          .toString()
          .trim();
        if (this.techEdit) {
          if (this.oldEmail != email) {
            this.checkTechnicianEmail(techinfo, index, email);
          }
          if (this.oldEmail == email) {
            techinfo.controls[index]["controls"][
              "primaryEmailValidationmessage"
            ].setValue("");
            techinfo.controls[index]["controls"]["emailvalid"].setValue(true);
            this.techindex += 1;
            if (techinfo.controls.length == index + 1) {
              this.saveTechnicianObj(techinfo, this.registerTechnicianList);
            } else {
              this.registerTechnician(techinfo, this.techindex);
            }
          }
        } else if (!this.techEdit) {
          this.checkTechnicianEmail(techinfo, index, email);
        }
      }
    } else {
      for (
        let index = 0;
        index < this.technicianForm.controls.technicianList["controls"].length;
        index++
      ) {
        if (
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["email"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["email"]["valid"] === false
        ) {
          this.checkEmailValidationMessage(
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["email"]["value"]
          );
        }
        if (
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["personalemail"]["value"] &&
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["personalemail"]["valid"] === false
        ) {
          this.checkPersonalEmailValidationMessage(
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["personalemail"]["value"]
          );
        }
        if (
          !this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["email"].value ||
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["email"].value == ""
        ) {
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["emailvalid"].setValue(true);
        }

        if (techinfo.controls[index]["controls"]["zipcode"].value && 
          techinfo.controls[index]["controls"]["zipcode"].value.length !=
          techinfo.controls[index]["controls"]["ziplength"].value
        ) {
          techinfo.controls[index]["controls"]["ziperror"].setValue(true);
        }
      }

      this.openModal(this.validationPopup);
      this.techSavebutton = false;
    }
  }

  personalEmailInput(value) {
    return this.frontDeskSharedService.personalEmailInput(this, value);
  }

  emailInput(value, index) {
    this.checkEmailValidationMessage(value);
    this.resetEmail(index);
  }

  openModal(template: TemplateRef<any>) {
    return this.frontDeskSharedService.openModal(this, template);
  }

  getAllTerminateTechnicianByTestCenter() {
    const data = {
      testcenterId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
      sortColumn: "createdOn",
      sortType: "desc",
    };
    this.appservice
      .getAllTerminateTechnicianByTestCenter(data)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.terminateEmpolyee = [];
          this.terminateEmpolyee = res["entity"];
          for (let index = 0; index < this.terminateEmpolyee.length; index++) {
            this.terminateEmpolyee[index].fullName =
              this.terminateEmpolyee[index].firstName +
              " " +
              this.terminateEmpolyee[index].lastName;

              this.terminateEmpolyee[index].dateTerminated = this.datepipe.transform(this.terminateEmpolyee[index].dateTerminated,"MMM dd, yyyy");
          }
        }
      });
  }

  getAllTechinicanByTestCenter() {
    this.technicianObj = {};
    const data = {
      testcenterId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
      sortColumn: "createdOn",
      sortType: "desc",
    };
    this.appservice.getAllTechnicianByTestCenter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.workingEmpolyee = [];
          this.workingEmpolyee = res["entity"];
          for (let index = 0; index < this.workingEmpolyee.length; index++) {
            this.workingEmpolyee[index].fullName =
              this.workingEmpolyee[index].firstName +
              " " +
              this.workingEmpolyee[index].lastName;
              this.workingEmpolyee[index].dateHired = this.datepipe.transform(this.workingEmpolyee[index].dateHired,"MMM dd, yyyy");
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getMobileMask(code, telNumber): string {
    return this.frontDeskSharedService.getMobileMask(this, code, telNumber);
  }

  getTechnicianByTechnicianId(technicianId) {
    if (technicianId) {
      this.appservice
        .getTechnicianByTechnicianIdwithType(technicianId, "all")
        .subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.selectedTechnician = res["entity"];
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
    }
  }

  public dropped(i, event: UploadEvent) {
    return this.employeeUploadSharedService.dropped(this, i, event);
  }

  removeUploadeddoc(index, docindex) {
    this.index = index;
    this.techid = docindex;
    this.heading = "Remove";
    this.popuptype = "documentdelete";
    this.generalvalidationMessage = "Do you want to remove the document?";
    this.openModal(this.deletePopup);
  }

  removeSelectedTechnician(index) {
    this.index = index;
    this.heading = "Remove";
    this.popuptype = "removetech";
    this.generalvalidationMessage = "Do you want to remove the Technologist?";
    this.openModal(this.deletePopup);
  }

  askpopupforRemovetechnician(index, techid, type) {
    this.index = index;
    this.techid = techid;
    this.heading = "Remove";
    this.popuptype = "delete";
    this.type = type;
    this.generalvalidationMessage = "Do you want to remove the Technologist?";
    this.openModal(this.deletePopup);
  }

  cancelModifyTechnician(index, techid, type) {
    this.index = index;
    this.techid = techid;
    this.heading = "Info";
    this.popuptype = "cancel";
    this.type = type;
    this.generalvalidationMessage = "Do you want to cancel the modify?";
    this.openModal(this.deletePopup);
  }

  askPopupForModifyTechnician(id, index, type) {
    this.techid = id;
    let valid = false;
    if (this.technicianForm.controls.technicianList["controls"].length > 0) {
      if (
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "firstName"
        ]["value"] ||
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "lastName"
        ]["value"] ||
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "email"
        ]["value"]
      ) {
        valid = true;
      }

      if (valid) {
        this.heading = "Info";
        this.popuptype = "modify";
        this.generalvalidationMessage =
          "You have a unsaved Technologist, Please save or it will lost";
        this.openModal(this.editPopup);
      } else {
        this.popuptype = "modify";
        this.modifyTechnician(this.techid);
      }
    } else {
      this.popuptype = "modify";
      this.modifyTechnician(this.techid);
    }
  }

  cancelModify() {
    this.popuptype = "notmodify";
    this.techEdit = false;
    this.scrollTop("scrollme");
    this.technicianinfosubmit = false;
    this.technicianObj = {};
    this.technicianForm.reset();
    this.oldEmail = "";
    this.oldMobile = "";
    this.oldMobileCode = "";
    for (
      let index = 0;
      index < this.technicianForm.controls.technicianList["controls"].length;
      index++
    ) {
      if (this.technicianForm.controls.technicianList["controls"].length > 1) {
        this.technicianForm.controls.technicianList["controls"].splice(
          index,
          1
        );
      }
    }
    if (localStorage.getItem("countryId") != null) {
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "country"
      ].setValue(localStorage.getItem("countryId"));
      if (localStorage.getItem("countryId") == "101") {
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "techdialcode"
        ].setValue("+91");
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "techdialphn"
        ].setValue("+91");
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "emergencyContactDialcode"
        ].setValue("+91");
      }

      if (localStorage.getItem("countryId") == "231") {
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "techdialcode"
        ].setValue("+1");
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "techdialphn"
        ].setValue("+1");
        this.technicianForm.controls.technicianList["controls"][0]["controls"][
          "emergencyContactDialcode"
        ].setValue("+1");
      }

      this.getStateList(0, localStorage.getItem("countryId"));
      this.changeCountry(0, localStorage.getItem("countryId"));
    } else {
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "country"
      ].setValue("default");
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "techdialcode"
      ].setValue("default");
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "techdialphn"
      ].setValue("default");
      this.technicianForm.controls.technicianList["controls"][0]["controls"][
        "emergencyContactDialcode"
      ].setValue("default");
    }

    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "state"
    ].setValue("default");
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "dateHired"
    ].setValue({ date: null });
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "equipments"
    ] = this.formBuilder.array([]);
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "terminatedDate"
    ].setValue({ date: null });
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "schoolList"
    ] = this.formBuilder.array([this.addNewSchool()]);
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "licenseList"
    ] = this.formBuilder.array([this.addNewLicense()]);
    this.technicianForm.controls.technicianList["controls"][0]["controls"][
      "documentList"
    ] = this.formBuilder.array([]);
    this.getallExams(0, localStorage.getItem("testCenterId"));
  }

  triggerPopupFordoucmentselector() {
    document.getElementById("uploadDocument").click();
  }

  sendemailLink(index, technicianForm) {
    if (technicianForm.valid) {
      const email = this.technicianForm.controls.technicianList["controls"][
        index
      ]["controls"]["email"].value;
      if (email && email.match(environment.emailPattern)) {
        const data = {
          email: email,
        };
        this.appservice.generateLink(data).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.backendmessage = this.techmessage.mobLinksend;
              setTimeout(() => {
                this.backendmessage = "";
              }, 5000);
            } else if (res && res["status"] && res["status"]["status"] == 229) {
              this.generalvalidationMessage = this.techmessage.giveRegTechEmail;
              this.openModal(this.generalvalidation);
            } else if (res && res["status"] && res["status"]["status"] == 238) {
              this.generalvalidationMessage = this.techmessage.unverifyTech;
              this.openModal(this.generalvalidation);
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
      } else {
        this.generalvalidationMessage = this.techmessage.validEmail;
        this.openModal(this.generalvalidation);
      }
    } else {
      this.generalvalidationMessage = this.techmessage.addressHighlight;
      this.technicianinfosubmit = true;
      this.openModal(this.generalvalidation);
    }
  }

  sendMobileAppLink(index, technicianForm, type) {
    if (technicianForm.valid) {
      if (!this.mobilechecking) {
        this.mobilechecking = true;
        if (
          type === "mobile" &&
          (this.oldMobile !=
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["techMobile"].value ||
            this.oldMobileCode !=
              this.technicianForm.controls.technicianList["controls"][index][
                "controls"
              ]["techdialcode"].value)
        ) {
          this.mobilechecking = false;
          this.generalvalidationMessage = this.techmessage.savetech;
          this.technicianinfosubmit = true;
          this.openModal(this.generalvalidation);
          return;
        } else if (
          type == "email" &&
          this.oldEmail !=
            this.technicianForm.controls.technicianList["controls"][index][
              "controls"
            ]["email"].value
        ) {
          this.mobilechecking = false;
          this.generalvalidationMessage = this.techmessage.savetech;
          this.technicianinfosubmit = true;
          this.openModal(this.generalvalidation);
          return;
        }

        if (
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["technicianId"] &&
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["technicianId"].value
        ) {
          const techId = this.technicianForm.controls.technicianList[
            "controls"
          ][index]["controls"]["technicianId"].value;
          this.appservice.generatelinktotechnician(techId, type).subscribe(
            (res) => {
              if (res && res["status"] && res["status"]["status"] == 200) {
                if (type == "mobile") {
                  this.backendmessage = this.techmessage.mobLinksendtomobile;
                } else {
                  this.backendmessage = this.techmessage.mobLinksend;
                }
                setTimeout(() => {
                  this.backendmessage = "";
                }, 5000);
              } else if (
                res &&
                res["status"] &&
                res["status"]["status"] == 229
              ) {
                this.generalvalidationMessage = this.techmessage.giveRegTechEmail;
                this.openModal(this.generalvalidation);
              } else if (
                res &&
                res["status"] &&
                res["status"]["status"] == 227
              ) {
                this.generalvalidationMessage = this.techmessage.terminatedTech;
                this.openModal(this.generalvalidation);
              } else if (
                res &&
                res["status"] &&
                res["status"]["status"] == 238
              ) {
                this.generalvalidationMessage = this.techmessage.unverifyTech;
                this.openModal(this.generalvalidation);
              }
              this.mobilechecking = false;
            },
            (err) => {
              this.appservice.sessionOut(err);
              this.mobilechecking = false;
            }
          );
        } else {
          this.mobilechecking = false;
          this.generalvalidationMessage = this.techmessage.savetech;
          this.openModal(this.generalvalidation);
        }
      }
    } else {
      this.generalvalidationMessage = this.techmessage.addressHighlight;
      this.technicianinfosubmit = true;
      this.openModal(this.generalvalidation);
    }
  }

  triggerPopup() {
    if (this.popuptype == "delete") {
      this.deleteTechnician(this.index, this.techid);
    }
    if (this.popuptype == "modify") {
      this.modifyTechnician(this.techid);
    }
    if (this.popuptype == "removelicense") {
      this.technicianForm.controls.technicianList["controls"][
        this.selectedIndex
      ]["controls"]["licenseList"]["controls"].splice(this.selectedRowIndex, 1);
    }
    if (this.popuptype == "removeschool") {
      this.technicianForm.controls.technicianList["controls"][
        this.selectedIndex
      ]["controls"]["schoolList"]["controls"].splice(this.selectedRowIndex, 1);
    }
    if (this.popuptype == "documentdelete") {
      this.technicianForm.controls.technicianList["controls"][this.index][
        "controls"
      ]["documentList"]["controls"].splice(this.techid, 1);
    }
    if (this.popuptype == "removetech") {
      this.removeTechnician(this.index);
    }
    document.getElementById("closepopup").click();
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  getTasks() {
    return this.technicianForm.get("technicianList")["controls"];
  }

  modifyTechnician(techid) {
    this.technicianObj = {};
    this.techEdit = true;
    if (techid) {
      this.appservice
        .getTechnicianByTechnicianIdwithType(techid, "all")
        .subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              for (
                let index = 0;
                index <
                this.technicianForm.controls.technicianList["controls"].length;
                index++
              ) {
                if (
                  this.technicianForm.controls.technicianList["controls"]
                    .length > 1
                ) {
                  this.technicianForm.controls.technicianList[
                    "controls"
                  ].splice(index, 1);
                }
              }
              this.scrollTop("scrollme");
              this.technicianObj = res["entity"];
              if (this.usertype == "1") {
                this.getallExams(0, this.technicianObj["testCenterId"]);
              }
              this.technicianForm.reset();
              this.oldEmail = res["entity"]["email"];
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["firstName"].setValue(res["entity"]["firstName"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["lastName"].setValue(res["entity"]["lastName"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["initial"].setValue(res["entity"]["initial"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["address1"].setValue(res["entity"]["address"]["addressLine1"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["address2"].setValue(res["entity"]["address"]["addressLine2"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["zipcode"].setValue(res["entity"]["address"]["zipCode"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["areaName"].setValue(res["entity"]["address"]["areaName"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["country"].setValue(res["entity"]["address"]["country"]["id"]);
              if (
                res["entity"]["address"]["country"]["id"] &&
                res["entity"]["address"]["country"]["id"] == 101
              ) {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziplength"].setValue(6);
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["zipmask"].setValue("000000");
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziperror"].setValue(false);
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziplable"].setValue("Pin code");
              }
              if (
                res["entity"]["address"]["country"]["id"] &&
                res["entity"]["address"]["country"]["id"] == 231
              ) {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziplength"].setValue(5);
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["zipmask"].setValue("00000");
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziperror"].setValue(false);
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["ziplable"].setValue("Zip code");
              }
              this.getStateList(
                0,
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["country"].value
              );

              if(res["entity"]["address"]["state"] && res["entity"]["address"]["state"]["id"]){
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["state"].setValue(res["entity"]["address"]["state"]["id"]);
              }else {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["state"].setValue("default");
              }
              
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["city"].setValue(res["entity"]["address"]["cityName"]);

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["techdialphn"].setValue(res["entity"]["phoneCode"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["techtelphn"].setValue(res["entity"]["phoneNumber"]);
              this.changeCountrycode(
                0,
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["techdialphn"]["value"],
                "techdialphn"
              );
              this.oldMobile = res["entity"]["telNumber"];
              this.oldMobileCode = res["entity"]["telCode"];
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["techdialcode"].setValue(res["entity"]["telCode"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["techMobile"].setValue(res["entity"]["telNumber"]);
              this.changeCountrycode(
                0,
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["techdialcode"]["value"],
                "techdialcode"
              );

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["emergencyContactName"].setValue(
                res["entity"]["emergencyContactInfo"]["firstName"]
              );
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["emergencyContactDialcode"].setValue(
                res["entity"]["emergencyContactInfo"]["phoneCode"]
              );
              this.changeCountrycode(
                0,
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["emergencyContactDialcode"]["value"],
                "emergencyContactDialcode"
              );
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["emergencyContactNum"].setValue(
                res["entity"]["emergencyContactInfo"]["phoneNumber"]
              );
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["technicianId"].setValue(res["entity"]["id"]);

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["emailvalid"].setValue(true);
              const localdate = res["entity"]["dateHired"]
                ? moment.utc(res["entity"]["dateHired"]).toDate()
                : null;

              if (localdate) {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["dateHired"].setValue({
                  date: {
                    year: localdate.getFullYear(),
                    month: localdate.getMonth() + 1,
                    day: localdate.getDate(),
                  },
                });
              } else {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["dateHired"].setValue({ date: null });
              }

              const localTerminatedate = res["entity"]["dateTerminated"]
                ? moment.utc(res["entity"]["dateTerminated"]).toDate()
                : null;

              if (localTerminatedate) {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["terminatedDate"].setValue({
                  date: {
                    year: localTerminatedate.getFullYear(),
                    month: localTerminatedate.getMonth() + 1,
                    day: localTerminatedate.getDate(),
                  },
                });
              } else {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["terminatedDate"].setValue({ date: null });
              }

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["vacationhrs"].setValue(res["entity"]["vacationDays"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["personalhrs"].setValue(res["entity"]["personalDays"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["sickhrs"].setValue(res["entity"]["sickDays"]);

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["personalemail"].setValue(res["entity"]["personalEmail"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["email"].setValue(res["entity"]["email"]);
              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["licenseList"] = this.formBuilder.array([]);
              if (
                res["entity"]["license"] &&
                res["entity"]["license"].length > 0
              ) {
                for (
                  let index = 0;
                  index < res["entity"]["license"].length;
                  index++
                ) {
                  var issueddate = res["entity"]["license"][index].issuedOn
                    .toString()
                    .split("-");
                  var expireddate = res["entity"]["license"][index].expiredOn
                    .toString()
                    .split("-");
                  var { issuedon, expired } = this.buildIssuedExpiredDates(
                    issueddate,
                    expireddate
                  );

                  this.technicianForm.controls.technicianList["controls"][0][
                    "controls"
                  ]["licenseList"]["controls"].push(
                    this.formBuilder.group({
                      id: [res["entity"]["license"][index].id],
                      license: [res["entity"]["license"][index].license],
                      issued: [issuedon],
                      expired: [expired],
                      issuedDatePickerOptions: [
                        {
                          dateFormat: "mmm dd, yyyy",
                          showClearDateBtn: false,
                          editableDateField: true,
                          indicateInvalidDate: true,
                        },
                      ],
                      expiredDatePickerOptions: [
                        {
                          dateFormat: "mmm dd, yyyy",
                          showClearDateBtn: false,
                          editableDateField: true,
                          indicateInvalidDate: true,
                        },
                      ],
                    })
                  );
                }
              } else {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["licenseList"]["controls"].push(
                  this.formBuilder.group({
                    id: [""],
                    license: [""],
                    issued: [{ date: null }],
                    expired: [{ date: null }],
                    issuedDatePickerOptions: [
                      {
                        dateFormat: "mmm dd, yyyy",
                        showClearDateBtn: false,
                        editableDateField: true,
                        indicateInvalidDate: true,
                      },
                    ],
                    expiredDatePickerOptions: [
                      {
                        dateFormat: "mmm dd, yyyy",
                        showClearDateBtn: false,
                        editableDateField: true,
                        indicateInvalidDate: true,
                      },
                    ],
                  })
                );
              }

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["schoolList"] = this.formBuilder.array([]);
              if (
                res["entity"]["school"] &&
                res["entity"]["school"].length > 0
              ) {
                for (
                  let index = 0;
                  index < res["entity"]["school"].length;
                  index++
                ) {
                  var issueddate = res["entity"]["school"][index].fromYear
                    .toString()
                    .split("-");
                  var expireddate = res["entity"]["school"][index].toYear
                    .toString()
                    .split("-");
                  var { issuedon, expired } = this.buildIssuedExpiredDates(
                    issueddate,
                    expireddate
                  );

                  this.technicianForm.controls.technicianList["controls"][0][
                    "controls"
                  ]["schoolList"]["controls"].push(
                    this.formBuilder.group({
                      id: [res["entity"]["school"][index].id],
                      schoolAtnd: [
                        {
                          value: res["entity"]["school"][index].school,
                          disabled: false,
                        },
                      ],
                      schoolFrm: [issuedon],
                      schoolTo: [expired],
                      valid: [{ value: true }],
                      schoolstartDatePicketOption: [
                        {
                          dateFormat: "mmm dd, yyyy",
                          showClearDateBtn: false,
                          editableDateField: true,
                          indicateInvalidDate: true,
                        },
                      ],
                      schoolendDatePicketOption: [
                        {
                          dateFormat: "mmm dd, yyyy",
                          showClearDateBtn: false,
                          editableDateField: true,
                          indicateInvalidDate: true,
                        },
                      ],
                    })
                  );
                }
              } else {
                this.technicianForm.controls.technicianList["controls"][0][
                  "controls"
                ]["schoolList"]["controls"].push(
                  this.formBuilder.group({
                    id: [""],
                    schoolAtnd: [{ value: "", disabled: false }],
                    schoolFrm: [{ value: "", disabled: false }],
                    schoolTo: [{ value: "", disabled: false }],
                    valid: [{ value: true }],
                    schoolstartDatePicketOption: [
                      {
                        dateFormat: "mmm dd, yyyy",
                        showClearDateBtn: false,
                        editableDateField: true,
                        indicateInvalidDate: true,
                      },
                    ],
                    schoolendDatePicketOption: [
                      {
                        dateFormat: "mmm dd, yyyy",
                        showClearDateBtn: false,
                        editableDateField: true,
                        indicateInvalidDate: true,
                      },
                    ],
                  })
                );
              }

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["documentList"] = this.formBuilder.array([]);
              if (
                res["entity"]["document"] &&
                res["entity"]["document"].length > 0
              ) {
                for (
                  let index = 0;
                  index < res["entity"]["document"].length;
                  index++
                ) {
                  this.technicianForm.controls.technicianList["controls"][0][
                    "controls"
                  ]["documentList"]["controls"].push(
                    this.formBuilder.group({
                      id: [res["entity"]["document"][index].id],
                      documentoriginalname: [
                        res["entity"]["document"][index].documentoriginalname,
                      ],
                      uploaddoc: [res["entity"]["document"][index].document],
                      uploadFinish: [false],
                      uploadValid: [true],
                      percentage: [0],
                      errorMessage: [""],
                    })
                  );
                }
              }

              this.technicianForm.controls.technicianList["controls"][0][
                "controls"
              ]["equipments"] = this.formBuilder.array([]);
              for (let e = 0; e < this.exams.length; e++) {
                if (
                  res["entity"]["equipments"] &&
                  res["entity"]["equipments"].length > 0
                ) {
                  let examAvailable = false;
                  let techexam = null;
                  for (
                    let index = 0;
                    index < res["entity"]["equipments"].length;
                    index++
                  ) {
                    if (
                      res["entity"]["equipments"][index]["exam"]["id"] ==
                      this.exams[e].id
                    ) {
                      examAvailable = true;
                      techexam = res["entity"]["equipments"][index];
                      break;
                    }
                  }
                  if (examAvailable && techexam) {
                    this.technicianForm.controls.technicianList["controls"][0][
                      "controls"
                    ]["equipments"]["controls"].push(
                      this.formBuilder.group({
                        checked: [true, Validators.required],
                        active: [this.exams[e]["active"], Validators.required],
                        exam: [this.exams[e]["exam"], Validators.required],
                        id: [this.exams[e]["id"], Validators.required],
                        examshortname: [
                          this.exams[e]["examshortname"] === "MRI" ||
                          this.exams[e]["examshortname"] === "CTS"
                            ? this.exams[e]["examshortname"] === "MRI"
                              ? "MRI/MRA"
                              : "CTS/CTA"
                            : this.exams[e]["examshortname"],
                          Validators.required,
                        ],
                        deleted: [
                          this.exams[e]["deleted"],
                          Validators.required,
                        ],
                        techEqId: [techexam.id],
                      })
                    );
                  } else {
                    this.technicianForm.controls.technicianList["controls"][0][
                      "controls"
                    ]["equipments"]["controls"].push(
                      this.formBuilder.group({
                        checked: [false, Validators.required],
                        active: [this.exams[e]["active"], Validators.required],
                        exam: [this.exams[e]["exam"], Validators.required],
                        id: [this.exams[e]["id"], Validators.required],
                        examshortname: [
                          this.exams[e]["examshortname"] === "MRI" ||
                          this.exams[e]["examshortname"] === "CTS"
                            ? this.exams[e]["examshortname"] === "MRI"
                              ? "MRI/MRA"
                              : "CTS/CTA"
                            : this.exams[e]["examshortname"],
                          Validators.required,
                        ],
                        deleted: [
                          this.exams[e]["deleted"],
                          Validators.required,
                        ],
                        techEqId: [""],
                      })
                    );
                  }
                }
              }
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
    }
  }

  roundprocessvalue(value): number {
    return this.frontDeskSharedService.roundprocessvalue(this, value);
  }

  getFirstIndex(index) {
    if (
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["lastName"].value &&
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["firstName"].value
    ) {
      const lastNameletter = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["lastName"].value
        .charAt(0)
        .toUpperCase();
      const firstNameletter = this.technicianForm.controls.technicianList[
        "controls"
      ][index]["controls"]["firstName"].value
        .charAt(0)
        .toUpperCase();
      this.technicianForm.controls.technicianList["controls"][index][
        "controls"
      ]["initial"].setValue(firstNameletter + lastNameletter);
    }
  }

  deleteTechnician(index, techid) {
    this.appservice.deleteTechinicanByTechnicianId(techid).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          if (this.type == "w") {
            this.workingEmpolyee.splice(index, 1);
          } else if (this.type == "t") {
            this.terminateEmpolyee.splice(index, 1);
          }
          this.backendmessage = this.techmessage.deleteSuccess;

          setTimeout(() => {
            this.backendmessage = "";
          }, 5000);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getStateList(index, countryid) {
    this.statedisable = true;
    this.appservice.getState(countryid).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.technicianForm.controls.technicianList["controls"][index][
            "controls"
          ]["stateList"].setValue(res["entity"]);
        }
        this.statedisable = false;
      },
      (err) => {
        this.statedisable = false;
        this.appservice.sessionOut(err);
      }
    );
  }

  getcountry() {
    return this.frontDeskSharedService.getcountry(this);
  }

  public charactersOnly(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[a-zA-Z\\ ]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }
}
